{
  "blockType": "card-product",
  "root": {
    "children": [
      {
        "children": [
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 500,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  16,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "children": [
              {
                "className": "text-3xl font-bold tracking-tight text-foreground sm:text-4xl",
                "id": "product-title",
                "level": "2",
                "text": "Featured Products",
                "type": "heading"
              },
              {
                "className": "text-lg text-muted-foreground",
                "id": "product-subtitle",
                "text": "Handpicked selection of our most popular items",
                "type": "text"
              }
            ],
            "className": "flex flex-col gap-2",
            "id": "product-header",
            "type": "container"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 400,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  20,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              },
              "stagger": 60
            },
            "children": [
              {
                "children": [
                  {
                    "children": [
                      {
                        "alt": "Wireless Headphones",
                        "className": "h-full w-full object-cover transition-transform duration-500 group-hover:scale-105",
                        "id": "p1-img",
                        "src": "/img/product-1.jpg",
                        "type": "image"
                      },
                      {
                        "className": "absolute left-3 top-3 text-white",
                        "id": "p1-badge",
                        "text": "Sale",
                        "type": "badge",
                        "variant": "default"
                      }
                    ],
                    "className": "relative aspect-square overflow-hidden bg-muted",
                    "id": "p1-img-wrap",
                    "type": "container"
                  },
                  {
                    "children": [
                      {
                        "className": "text-xs font-medium uppercase tracking-wider text-primary",
                        "id": "p1-category",
                        "text": "Electronics",
                        "type": "text"
                      },
                      {
                        "className": "text-sm font-semibold text-foreground",
                        "id": "p1-name",
                        "level": "3",
                        "text": "Wireless Noise-Cancelling Headphones",
                        "type": "heading"
                      },
                      {
                        "children": [
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p1-s1",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p1-s2",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p1-s3",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p1-s4",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400/40 text-yellow-400/40",
                            "icon": "star",
                            "id": "p1-s5",
                            "type": "icon"
                          },
                          {
                            "className": "text-xs text-muted-foreground",
                            "id": "p1-rating-text",
                            "text": "4.2 (128)",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-center gap-1.5",
                        "id": "p1-stars",
                        "type": "container"
                      },
                      {
                        "children": [
                          {
                            "className": "text-lg font-bold text-foreground",
                            "id": "p1-price",
                            "text": "$79.99",
                            "type": "text"
                          },
                          {
                            "className": "text-sm text-muted-foreground line-through",
                            "id": "p1-original",
                            "text": "$129.99",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-baseline gap-2",
                        "id": "p1-price-row",
                        "type": "container"
                      },
                      {
                        "className": "w-full min-h-11",
                        "icon": "shopping-cart",
                        "iconPosition": "left",
                        "id": "p1-add-btn",
                        "interaction": {
                          "cursor": "pointer",
                          "hover": {
                            "scale": 1.02
                          },
                          "press": {
                            "scale": 0.97
                          },
                          "transition": {
                            "curve": "ease-out",
                            "duration": 150,
                            "properties": [
                              "transform"
                            ]
                          }
                        },
                        "size": "sm",
                        "text": "Add to Cart",
                        "type": "button",
                        "variant": "default"
                      }
                    ],
                    "className": "flex flex-col gap-3 p-4",
                    "id": "p1-body",
                    "type": "container"
                  }
                ],
                "className": "group flex flex-col overflow-hidden rounded-2xl border border-border/50 bg-card shadow-sm",
                "id": "product-card-1",
                "interaction": {
                  "cursor": "pointer",
                  "hover": {
                    "scale": 1.02,
                    "shadow": "xl",
                    "translateY": -4
                  },
                  "transition": {
                    "curve": "ease-out",
                    "duration": 250,
                    "properties": [
                      "transform",
                      "box-shadow"
                    ]
                  }
                },
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "alt": "Smart Watch",
                        "className": "h-full w-full object-cover transition-transform duration-500 group-hover:scale-105",
                        "id": "p2-img",
                        "src": "/img/product-2.jpg",
                        "type": "image"
                      }
                    ],
                    "className": "relative aspect-square overflow-hidden bg-muted",
                    "id": "p2-img-wrap",
                    "type": "container"
                  },
                  {
                    "children": [
                      {
                        "className": "text-xs font-medium uppercase tracking-wider text-primary",
                        "id": "p2-category",
                        "text": "Wearables",
                        "type": "text"
                      },
                      {
                        "className": "text-sm font-semibold text-foreground",
                        "id": "p2-name",
                        "level": "3",
                        "text": "Smart Fitness Watch Pro",
                        "type": "heading"
                      },
                      {
                        "children": [
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p2-s1",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p2-s2",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p2-s3",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p2-s4",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p2-s5",
                            "type": "icon"
                          },
                          {
                            "className": "text-xs text-muted-foreground",
                            "id": "p2-rating-text",
                            "text": "5.0 (342)",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-center gap-1.5",
                        "id": "p2-stars",
                        "type": "container"
                      },
                      {
                        "children": [
                          {
                            "className": "text-lg font-bold text-foreground",
                            "id": "p2-price",
                            "text": "$199.99",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-baseline gap-2",
                        "id": "p2-price-row",
                        "type": "container"
                      },
                      {
                        "className": "w-full min-h-11",
                        "icon": "shopping-cart",
                        "iconPosition": "left",
                        "id": "p2-add-btn",
                        "interaction": {
                          "cursor": "pointer",
                          "hover": {
                            "scale": 1.02
                          },
                          "press": {
                            "scale": 0.97
                          },
                          "transition": {
                            "curve": "ease-out",
                            "duration": 150,
                            "properties": [
                              "transform"
                            ]
                          }
                        },
                        "size": "sm",
                        "text": "Add to Cart",
                        "type": "button",
                        "variant": "default"
                      }
                    ],
                    "className": "flex flex-col gap-3 p-4",
                    "id": "p2-body",
                    "type": "container"
                  }
                ],
                "className": "group flex flex-col overflow-hidden rounded-2xl border border-border/50 bg-card shadow-sm",
                "id": "product-card-2",
                "interaction": {
                  "cursor": "pointer",
                  "hover": {
                    "scale": 1.02,
                    "shadow": "xl",
                    "translateY": -4
                  },
                  "transition": {
                    "curve": "ease-out",
                    "duration": 250,
                    "properties": [
                      "transform",
                      "box-shadow"
                    ]
                  }
                },
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "alt": "Laptop Stand",
                        "className": "h-full w-full object-cover transition-transform duration-500 group-hover:scale-105",
                        "id": "p3-img",
                        "src": "/img/product-3.jpg",
                        "type": "image"
                      },
                      {
                        "className": "absolute left-3 top-3",
                        "id": "p3-badge",
                        "text": "New",
                        "type": "badge",
                        "variant": "secondary"
                      }
                    ],
                    "className": "relative aspect-square overflow-hidden bg-muted",
                    "id": "p3-img-wrap",
                    "type": "container"
                  },
                  {
                    "children": [
                      {
                        "className": "text-xs font-medium uppercase tracking-wider text-primary",
                        "id": "p3-category",
                        "text": "Accessories",
                        "type": "text"
                      },
                      {
                        "className": "text-sm font-semibold text-foreground",
                        "id": "p3-name",
                        "level": "3",
                        "text": "Adjustable Aluminum Laptop Stand",
                        "type": "heading"
                      },
                      {
                        "children": [
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p3-s1",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p3-s2",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p3-s3",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p3-s4",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400/30 text-yellow-400/30",
                            "icon": "star",
                            "id": "p3-s5",
                            "type": "icon"
                          },
                          {
                            "className": "text-xs text-muted-foreground",
                            "id": "p3-rating-text",
                            "text": "4.5 (67)",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-center gap-1.5",
                        "id": "p3-stars",
                        "type": "container"
                      },
                      {
                        "children": [
                          {
                            "className": "text-lg font-bold text-foreground",
                            "id": "p3-price",
                            "text": "$49.99",
                            "type": "text"
                          },
                          {
                            "className": "text-sm text-muted-foreground line-through",
                            "id": "p3-original",
                            "text": "$69.99",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-baseline gap-2",
                        "id": "p3-price-row",
                        "type": "container"
                      },
                      {
                        "className": "w-full min-h-11",
                        "icon": "shopping-cart",
                        "iconPosition": "left",
                        "id": "p3-add-btn",
                        "interaction": {
                          "cursor": "pointer",
                          "hover": {
                            "scale": 1.02
                          },
                          "press": {
                            "scale": 0.97
                          },
                          "transition": {
                            "curve": "ease-out",
                            "duration": 150,
                            "properties": [
                              "transform"
                            ]
                          }
                        },
                        "size": "sm",
                        "text": "Add to Cart",
                        "type": "button",
                        "variant": "default"
                      }
                    ],
                    "className": "flex flex-col gap-3 p-4",
                    "id": "p3-body",
                    "type": "container"
                  }
                ],
                "className": "group flex flex-col overflow-hidden rounded-2xl border border-border/50 bg-card shadow-sm",
                "id": "product-card-3",
                "interaction": {
                  "cursor": "pointer",
                  "hover": {
                    "scale": 1.02,
                    "shadow": "xl",
                    "translateY": -4
                  },
                  "transition": {
                    "curve": "ease-out",
                    "duration": 250,
                    "properties": [
                      "transform",
                      "box-shadow"
                    ]
                  }
                },
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "alt": "Mechanical Keyboard",
                        "className": "h-full w-full object-cover transition-transform duration-500 group-hover:scale-105",
                        "id": "p4-img",
                        "src": "/img/product-4.jpg",
                        "type": "image"
                      }
                    ],
                    "className": "relative aspect-square overflow-hidden bg-muted",
                    "id": "p4-img-wrap",
                    "type": "container"
                  },
                  {
                    "children": [
                      {
                        "className": "text-xs font-medium uppercase tracking-wider text-primary",
                        "id": "p4-category",
                        "text": "Peripherals",
                        "type": "text"
                      },
                      {
                        "className": "text-sm font-semibold text-foreground",
                        "id": "p4-name",
                        "level": "3",
                        "text": "Compact Mechanical Keyboard",
                        "type": "heading"
                      },
                      {
                        "children": [
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p4-s1",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p4-s2",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p4-s3",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400 text-yellow-400",
                            "icon": "star",
                            "id": "p4-s4",
                            "type": "icon"
                          },
                          {
                            "className": "h-3.5 w-3.5 fill-yellow-400/60 text-yellow-400/60",
                            "icon": "star",
                            "id": "p4-s5",
                            "type": "icon"
                          },
                          {
                            "className": "text-xs text-muted-foreground",
                            "id": "p4-rating-text",
                            "text": "4.7 (203)",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-center gap-1.5",
                        "id": "p4-stars",
                        "type": "container"
                      },
                      {
                        "children": [
                          {
                            "className": "text-lg font-bold text-foreground",
                            "id": "p4-price",
                            "text": "$149.00",
                            "type": "text"
                          }
                        ],
                        "className": "flex items-baseline gap-2",
                        "id": "p4-price-row",
                        "type": "container"
                      },
                      {
                        "className": "w-full min-h-11",
                        "icon": "shopping-cart",
                        "iconPosition": "left",
                        "id": "p4-add-btn",
                        "interaction": {
                          "cursor": "pointer",
                          "hover": {
                            "scale": 1.02
                          },
                          "press": {
                            "scale": 0.97
                          },
                          "transition": {
                            "curve": "ease-out",
                            "duration": 150,
                            "properties": [
                              "transform"
                            ]
                          }
                        },
                        "size": "sm",
                        "text": "Add to Cart",
                        "type": "button",
                        "variant": "default"
                      }
                    ],
                    "className": "flex flex-col gap-3 p-4",
                    "id": "p4-body",
                    "type": "container"
                  }
                ],
                "className": "group flex flex-col overflow-hidden rounded-2xl border border-border/50 bg-card shadow-sm",
                "id": "product-card-4",
                "interaction": {
                  "cursor": "pointer",
                  "hover": {
                    "scale": 1.02,
                    "shadow": "xl",
                    "translateY": -4
                  },
                  "transition": {
                    "curve": "ease-out",
                    "duration": 250,
                    "properties": [
                      "transform",
                      "box-shadow"
                    ]
                  }
                },
                "type": "container"
              }
            ],
            "className": "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 cogo-gap-element",
            "id": "product-grid",
            "type": "container"
          }
        ],
        "className": "mx-auto flex max-w-6xl flex-col gap-12 cogo-gap-section",
        "id": "card-product-inner",
        "type": "container"
      }
    ],
    "className": "px-6 py-16 lg:py-24",
    "id": "card-product-root",
    "type": "section"
  },
  "schemaVersion": "2.0"
}
